import styled from 'styled-components';

import { Checkbox as AntdCheckbox } from 'antd';

const CheckboxGroup = styled(AntdCheckbox.Group)`
    && .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${({ theme }) => theme.colour.primary};
        border-color: ${({ theme }) => theme.colour.primary};
    }
    && .ant-checkbox-checked::after {
        border-color: ${({ theme }) => theme.colour.primary};
    }

    && .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    && .ant-checkbox:hover .ant-checkbox-inner,
    && .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: ${({ theme }) => theme.colour.primary};
    }
    && .ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background-color: ${({ theme }) => theme.colour.primary};
    }
`;

export default CheckboxGroup;
